const authenticationRoutes: any = {
    path: '/',
    name: 'authentication',
    component: () => import('@/views/Authentication/views/Index/Index.vue'),
    redirect: { name: 'sign-in' },
    children: [
        {
            path: 'sign-in',
            name: 'sign-in',
            component: () => import('@/views/Authentication/views/Signin/Signin.vue'),
        },
        {
            path: 'sign-up',
            name: 'sign-up',
            component: () => import('@/views/Authentication/views/Signup/Signup.vue'),
        },
        {
            path: 'sign-up/email-sent',
            name: 'sign-up-email-sent',
            component: () => import('@/views/Authentication/views/Success/Success.vue'),
            meta: {
                alwaysAllowed: true,
            },
        },
        {
            path: 'reset-password',
            name: 'reset-password',
            component: () => import('@/views/Authentication/views/ResetPassword/ResetPassword.vue'),
        },
        {
            path: 'reset-password/link-sent',
            name: 'reset-password-link-sent',
            component: () => import('@/views/Authentication/views/Success/Success.vue'),
            meta: {
                alwaysAllowed: true,
            },
        },
        {
            path: 'set-password',
            name: 'set-password',
            component: () => import('@/views/Authentication/views/SetPassword/SetPassword.vue'),
            meta: {
                alwaysAllowed: true,
            },
        },
        {
            path: 'invite',
            name: 'invite',
            component: () => import('@/views/Authentication/views/Signup/Signup.vue'),
        },
        {
            name: 'success',
            path: 'success',
            component: () => import('@/views/Authentication/views/Success/Success.vue'),
            meta: {
                alwaysAllowed: true,
            },
        },
        {
            name: 'help',
            path: 'help',
            component: () => import('@/views/Authentication/views/Help/Help.vue'),
            meta: {
                alwaysAllowed: true,
            },
        },
    ],
}

export default authenticationRoutes
